import { forEachOfArray } from "@acng/frontend-bounty/array.js";
import { CTX_OBSERVE } from "../minify.js";
/**
 * @template X
 * @template {readonly import("../model/context/interface").Context<any>[]} T
 *
 * @param {Element} host
 *
 * @param {(
 *   value: {[P in keyof T]: T[P] extends Context<infer V> ? V : never},
 *   previous: {[P in keyof T]: T[P] extends Context<infer V> ? V | undefined : never}
 * ) => X} callback
 *
 * @param {T} contexts
 *
 * @returns {X}
 */
export function watch(host, callback, ...contexts) {
    let enablePropagation = false;
    /**
     * @type {any}
     */
    const allCurrent = [];
    /**
     * @type {any}
     */
    const allPrevious = [];
    // It might be good to be able to replace the listener without looking up tha context again
    // then this could be two loops
    // 1. CTX_OBSERVE to get the current value
    // 2. CTX_REPLACE the real listener (enablePropagation)
    // a.t.m. two CTX_OBSERVE would be possible but expensive.
    forEachOfArray(contexts, (ctx, i) => ctx[CTX_OBSERVE](host, (current) => {
        if (enablePropagation) {
            forEachOfArray(allCurrent, (v, j) => (allPrevious[j] = v));
            allCurrent[i] = current;
            callback(allCurrent, allPrevious);
        }
        else {
            allCurrent[i] = current;
        }
    }));
    enablePropagation = true;
    return callback(allCurrent, allPrevious);
}
